import React from 'react'
import { Link } from 'react-router-dom'
import SectionNavPills from '../components/SectionNavPills'

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SectionNavPills />
      <div className="container mx-auto px-4 py-14 md:py-20">
        <div className="max-w-4xl mx-auto">
          <header className="mb-6 md:mb-8 text-center">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Podmienky používania
            </h1>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-2xl mx-auto">
              Podmienky používania služieb EduMisia. Posledná aktualizácia: február 2026.
            </p>
          </header>

          <div className="bg-white rounded-2xl border border-gray-100 ring-1 ring-gray-50 shadow-sm p-6 sm:p-8 md:p-10 space-y-8">

            {/* V1 review notice (soft) */}
            <div className="p-4 bg-blue-50 border-l-4 border-blue-300 rounded">
              <p className="text-sm text-blue-900">
                Toto je verzia 1 podmienok používania. Text môže byť dopracovaný po právnej revízii. V prípade otázok nás kontaktujte na{' '}
                <a href="mailto:podpora@edumisia.sk" className="font-medium underline">podpora@edumisia.sk</a>.
              </p>
            </div>

            {/* 1. Úvodné ustanovenia */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                1. Úvodné ustanovenia
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  Tieto podmienky používania upravujú vzťah medzi poskytovateľom služby EduMisia
                  (ďalej len „poskytovateľ") a používateľom (ďalej len „používateľ").
                </p>
                <div className="pl-4 mt-3 space-y-1">
                  <p><strong>Poskytovateľ:</strong></p>
                  <p>Mgr. Vladislava Pajerová</p>
                  <p>Sídlo: Lipová 6459/4, 974 09 Banská Bystrica, Slovenská republika</p>
                  <p>IČO: 51360454</p>
                  <p>Vedený v registri: Okresný úrad Banská Bystrica</p>
                  <p>Číslo živnostenského registra: 430-58126</p>
                  <p>Email: <a href="mailto:podpora@edumisia.sk" className="text-blue-600">podpora@edumisia.sk</a></p>
                </div>
              </div>
            </section>

            {/* 2. Vymedzenie služieb */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                2. Vymedzenie poskytovaných služieb
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  EduMisia je online vzdelávacia platforma na prípravu na Testovanie 9.
                </p>
                <p>
                  EduMisia nie je oficiálnym testom Testovanie 9 ani oficiálnou službou organizátora skúšky.
                </p>
                <p>
                  Služba poskytuje prístup k online testom, výsledkom a vysvetleniam. Konkrétne:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>online prístup k testom pre prípravu na Testovanie 9,</li>
                  <li>vyhodnocovanie testov a zobrazenie výsledkov,</li>
                  <li>vysvetlenia a nápovedy k otázkam,</li>
                  <li>sledovanie pokroku a histórie výsledkov.</li>
                </ul>
                <p className="mt-3">
                  Služby sú poskytované prostredníctvom internetovej stránky EduMisia.
                </p>
              </div>
            </section>

            {/* 3. Registrácia a účet */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                3. Registrácia a používateľský účet
              </h2>
              <div className="text-gray-700 space-y-3">
                <p><strong>3.1</strong> Pre používanie služieb je potrebná registrácia pomocou emailovej adresy a hesla.</p>
                <p><strong>3.2</strong> Používateľ je povinný:</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Poskytnúť pravdivé a aktuálne údaje</li>
                  <li>Uchovávať prístupové údaje v tajnosti</li>
                  <li>Neposkytnúť prístup k účtu tretím osobám</li>
                  <li>Okamžite informovať poskytovateľa o neoprávnenom použití účtu</li>
                </ul>
                <p><strong>3.3</strong> Jeden účet je určený len pre jedného používateľa.</p>
                
                <div className="mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-400">
                  <p className="font-semibold text-yellow-900 mb-2">
                    Vekové obmedzenie pre nákup služieb
                  </p>
                  <p className="text-yellow-800">
                    <strong>3.4</strong> Balíček môže zakúpiť iba osoba staršia ako 18 rokov, alebo rodič či iný zákonný zástupca maloletého používateľa. Kliknutím na tlačidlo „Zakúpiť" kupujúci potvrdzuje, že spĺňa túto podmienku.
                  </p>
                </div>
              </div>
            </section>

            {/* 4. Platby a predplatné */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                4. Ceny, platby a predplatné
              </h2>
              <div className="text-gray-700 space-y-3">
                <p><strong>4.1 Cenník</strong></p>
                <p className="ml-4">
                  Cena balíčka je <strong>14,99 € / školský rok</strong>. Aktuálne ceny služieb nájdete aj na stránke{' '}
                  <Link to="/pricing" className="text-blue-600">/pricing</Link>. Všetky ceny sú uvedené vrátane DPH.
                </p>

                <p><strong>4.2 Platobné podmienky</strong></p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Platby sú spracovávané prostredníctvom platobnej brány Stripe.</li>
                  <li>Prístup k plateným službám je aktivovaný okamžite po úspešnej platbe.</li>
                  <li>Faktúru zasielame na email uvedený pri registrácii.</li>
                </ul>

                <p><strong>4.3 Obdobie prístupu</strong></p>
                <p className="ml-4">
                  Prístup platí do 31. mája daného školského roka. K zverejneným testom, výsledkom a vysvetleniam sa môžete vracať aj po ukončení hlavnej časti Testovania 9.
                </p>

                <p><strong>4.4 Obnovenie predplatného</strong></p>
                <p className="ml-4">
                  Balíček sa nepreddlžuje automaticky. Po 31. máji prístup končí, kým si používateľ nezakúpi nový balíček na nasledujúci školský rok.
                </p>
              </div>
            </section>

            {/* 5. Právo na odstúpenie */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                5. Právo na odstúpenie od zmluvy (spotrebiteľské práva)
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  <strong>5.1</strong> Spotrebiteľ má právo odstúpiť od zmluvy do 14 dní od uzavretia zmluvy 
                  bez uvedenia dôvodu.
                </p>
                <p>
                  <strong>5.2</strong> Ak spotrebiteľ začne používať služby pred uplynutím 14-dňovej lehoty, 
                  právo na odstúpenie zaniká v rozsahu už poskytnutých služieb.
                </p>
                <p>
                  <strong>5.3</strong> Pre odstúpenie od zmluvy nás kontaktujte na <a href="mailto:podpora@edumisia.sk" className="text-blue-600">podpora@edumisia.sk</a>.
                </p>
              </div>
            </section>

            {/* 6. Zodpovednosť */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                6. Zodpovednosť a obmedzenia
              </h2>
              <div className="text-gray-700 space-y-3">
                <p><strong>6.1</strong> Poskytovateľ:</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Nezodpovedá za konečný výsledok používateľa pri Testovaní 9</li>
                  <li>Služby sú určené na prípravu a cvičenie, nie sú náhradou oficiálneho testovania</li>
                  <li>Nezaručuje nepretržitú dostupnosť služieb (technické údržby, výpadky)</li>
                  <li>Nezodpovedá za škody spôsobené nesprávnym použitím služieb</li>
                </ul>
                
                <p><strong>6.2</strong> Používateľ:</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>Je zodpovedný za zachovanie prístupových údajov</li>
                  <li>Nesmie zneužívať služby (napr. hromadné sťahovanie obsahu, zdieľanie prístupu)</li>
                  <li>Súhlasí s použitím služieb v súlade s týmito podmienkami</li>
                </ul>
              </div>
            </section>

            {/* 7. Duševné vlastníctvo */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                7. Duševné vlastníctvo
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  <strong>7.1</strong> Všetok obsah platformy (testy, otázky, vysvetlenia, dizajn) je chránený 
                  autorskými právami a je majetkom poskytovateľa.
                </p>
                <p>
                  <strong>7.2</strong> Používateľ nadobúda právo používať obsah len na osobné vzdelávacie účely.
                </p>
                <p>
                  <strong>7.3</strong> Akékoľvek kopírovanie, šírenie alebo komerčné využitie obsahu bez súhlasu 
                  poskytovateľa je zakázané.
                </p>
              </div>
            </section>

            {/* 8. Zmeny podmienok */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                8. Zmena podmienok používania
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  <strong>8.1</strong> Poskytovateľ si vyhradzuje právo meniť tieto podmienky používania.
                </p>
                <p>
                  <strong>8.2</strong> O zmenách budú používatelia informovaní emailom minimálne 14 dní vopred.
                </p>
                <p>
                  <strong>8.3</strong> Ak používateľ nesúhlasí so zmenami, môže ukončiť účet.
                </p>
              </div>
            </section>

            {/* 9. Ukončenie služieb */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                9. Ukončenie používania služieb
              </h2>
              <div className="text-gray-700 space-y-3">
                <p><strong>9.1</strong> Používateľ môže kedykoľvek zrušiť svoj účet kontaktovaním podpory.</p>
                <p><strong>9.2</strong> Poskytovateľ si vyhradzuje právo zrušiť účet v prípade:</p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>porušenia týchto podmienok používania,</li>
                  <li>zneužívania služieb,</li>
                  <li>neoprávneného zdieľania obsahu.</li>
                </ul>
              </div>
            </section>

            {/* 10. Riešenie sporov */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                10. Riešenie sporov a záverečné ustanovenia
              </h2>
              <div className="text-gray-700 space-y-3">
                <p>
                  <strong>10.1</strong> Akékoľvek spory budú prednostne riešené dohodou.
                </p>
                <p>
                  <strong>10.2</strong> Spotrebiteľ má právo obrátiť sa na Slovenskú obchodnú inšpekciu 
                  alebo použiť platformu alternatívneho riešenia sporov.
                </p>
                <p>
                  <strong>10.3</strong> Tieto podmienky používania sa riadia právnym poriadkom Slovenskej republiky.
                </p>
              </div>
            </section>

            {/* Kontakt */}
            <section className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Kontakt
              </h2>
              <div className="text-gray-700">
                <p className="mb-2">
                  Pre otázky týkajúce sa podmienok používania nás kontaktujte:
                </p>
                <p>Email: <a href="mailto:podpora@edumisia.sk" className="text-blue-600">podpora@edumisia.sk</a></p>
                <p className="mt-2">
                  alebo navštívte našu <Link to="/contact" className="text-blue-600 hover:text-blue-700">kontaktnú stránku</Link>
                </p>
              </div>
            </section>

          </div>

          {/* Back to Home */}
          <div className="mt-8 text-center">
            <Link 
              to="/"
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              ← Späť na hlavnú stránku
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfUse
